import {
  SUA_TIEN_LAI,
  SUA_TIEN_LAI_SUCCESS,
  SUA_TIEN_LAI_FAILURE,
  SUA_TIEN_GOC,
  SUA_TIEN_GOC_SUCCESS,
  SUA_TIEN_GOC_FAILURE,
  SUA_TIEN_GOP,
  SUA_TIEN_GOP_SUCCESS,
  SUA_TIEN_GOP_FAILURE,
  NHAP_PHI_PHAT,
  NHAP_PHI_PHAT_SUCCESS,
  NHAP_PHI_PHAT_FAILURE,
} from './actionTypes';

export const suaTienLai = (dataPost, dataSearch) => ({
  type: SUA_TIEN_LAI,
  dataPost,
  dataSearch,
});

export const suaTienLaiSuccess = (data) => ({
  type: SUA_TIEN_LAI_SUCCESS,
  payload: data,
});

export const suaTienLaiFailure = () => ({
  type: SUA_TIEN_LAI_FAILURE,
});

export const suaTienGoc = (dataPost, dataSearch) => ({
  type: SUA_TIEN_GOC,
  dataPost,
  dataSearch,
});

export const suaTienGocSuccess = (data) => ({
  type: SUA_TIEN_GOC_SUCCESS,
  payload: data,
});

export const suaTienGocFailure = () => ({
  type: SUA_TIEN_GOC_FAILURE,
});


export const suaTienGop = (dataPost, dataSearch) => ({
  type: SUA_TIEN_GOP,
  dataPost,
  dataSearch,
});

export const suaTienGopSuccess = (data) => ({
  type: SUA_TIEN_GOP_SUCCESS,
  payload: data,
});

export const suaTienGopFailure = () => ({
  type: SUA_TIEN_GOP_FAILURE,
});



export const nhapPhiPhat = (dataPost, dataSearch) => ({
  type: NHAP_PHI_PHAT,
  dataPost,
  dataSearch,
});

export const nhapPhiPhatSuccess = (data) => ({
  type: NHAP_PHI_PHAT_SUCCESS,
  payload: data,
});

export const nhapPhiPhatFailure = () => ({
  type: NHAP_PHI_PHAT_FAILURE,
});
